export default "__VITE_ASSET__UU3F3ubG__"